import { render } from "./CardItem.vue?vue&type=template&id=6c1ff0b0&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"

import "./CardItem.vue?vue&type=style&index=0&id=6c1ff0b0&lang=scss&scoped=true"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1ff0b0"]])

export default __exports__